import "primeflex/primeflex.css";
import React, { useEffect, useState, useRef } from "react";
import { Button } from "primereact/button";
import { default as ApiService, default as apiService } from "../service/apiService";
import { Card } from "primereact/card";
import ViewConflictData from "../lookup/viewConlictData";
import KycComparisionInfo from "./kycComparisionInfo";
import { setDuplicateData } from "../../redux/routerSlice";
import { useDispatch, useSelector } from "react-redux";


const DataFrom = { B: 'Analysis with BOID Data', C: 'Analysis with Verified Data', D: 'Analysis with Unverified Data' }


const AnalysisDisplay = {
    B: (boidAnalysis, setViewConflicDialog, isCompany, flag) => {
        const dd = boidAnalysis;

        let exclusionList = [];
        const toList = (str) => {
            return str && str.split(',').filter(s => !exclusionList.includes(s))
                .reduce((a, v) => {
                    exclusionList.push(v);
                    return a ? a + ',' + v : v;
                }, null);
        };

        const per100Minor = toList(dd.per100Minor);
        const per100 = toList(dd.per100);
        const per100nCtznDob = toList(dd.per100nCtznDob);
        const per100FLNameCtznDob = toList(dd.per100FLNameCtznDob);
        const per100AllNameDobCtzn19 = toList(dd.per100AllNameDobCtzn19);

        const per90NDobCtzn19 = toList(dd.per90NDobCtzn19);
        const per90AllNameDob = toList(dd.per90AllNameDob);
        const per90AllNameCtzn = toList(dd.per90AllNameCtzn);
        const per90AllNameCtzn19 = toList(dd.per90AllNameCtzn19);
        const per90AllNameCtzn15 = toList(dd.per90AllNameCtzn15);
        const per90CtznDob = toList(dd.per90CtznDob);
        const per90NameCtzn = toList(dd.per90NameCtzn);
        const per90FLNameCtzn = toList(dd.per90FLNameCtzn);
        const per100Ctzn = toList(dd.per100Ctzn);

        const duplicate100 = [
            per100,
            per100nCtznDob,
            per100FLNameCtznDob,
            per100AllNameDobCtzn19,
            per100Minor
        ].filter(p => p).join(',');

        const duplicate90 = [
            per90NDobCtzn19,
            per90AllNameDob,
            per90AllNameCtzn,
            per90AllNameCtzn19,
            per90AllNameCtzn15,
            per90CtznDob,
            per90NameCtzn,
            per90FLNameCtzn,
            per100Ctzn
        ].filter(p => p).join(',');

        const duplicateAll = [duplicate100].filter(p => p).join(',');

        return (
            duplicate100 && <Card header={<span className="card-body-label">
                <a href="#" onClick={(e) => setViewConflicDialog(duplicateAll)}> {DataFrom.B}</a>
            </span>}>
                {duplicate100 &&
                    <p><span className="card-body-label">
                        <a href="#" onClick={(e) => setViewConflicDialog(duplicate100)}>100% match :</a>

                    </span></p>}

                {duplicate100 &&
                    <p>
                        <p style={{ padding: 5 }}>
                            {per100 && <p><span className="card-body-label">
                                {!isCompany ? 'Name, Family Detail, DOB and Citizenship(' + (flag ? 'Dst-No-Yr' : 'No') + ')' : 'Company name/Reg No/PAN'}:{' '}
                            </span>
                                <span className="card-body-text">
                                    <a href="#" onClick={(e) => setViewConflicDialog(per100)}>
                                        {per100}
                                    </a>
                                </span></p>}
                            {per100Minor && <p><span className="card-body-label">
                                Name, DOB and Minor Birth Certificate:{' '}
                            </span>
                                <span className="card-body-text">
                                    <a href="#" onClick={(e) => setViewConflicDialog(per100Minor)}>
                                        {per100Minor}
                                    </a>
                                </span></p>}
                            {per100FLNameCtznDob && <p><span className="card-body-label">
                                First Name, Last Name, DOB and Citizenship(Dst-No-Yr):{' '}
                            </span>
                                <span className="card-body-text">
                                    <a href="#" onClick={(e) => setViewConflicDialog(per100FLNameCtznDob)}>
                                        {per100FLNameCtznDob}
                                    </a>
                                </span></p>}
                            {per100AllNameDobCtzn19 && <p><span className="card-body-label">
                                Name, Family Detail, DOB and Citizenship(Dst-No):{' '}
                            </span>
                                <span className="card-body-text">
                                    <a href="#" onClick={(e) => setViewConflicDialog(per100AllNameDobCtzn19)}>
                                        {per100AllNameDobCtzn19}
                                    </a>
                                </span></p>}
                            {per100nCtznDob && <p><span className="card-body-label">
                                Name, DOB and Citizenship(Dst-No-Yr):{' '}
                            </span>
                                <span className="card-body-text">
                                    <a href="#" onClick={(e) => setViewConflicDialog(per100nCtznDob)}>
                                        {per100nCtznDob}
                                    </a>
                                </span></p>}</p>
                    </p>}
                {/* {duplicate90 &&
                    <p><span className="card-body-label">
                        <a href="#" onClick={(e) => setViewConflicDialog(duplicate90)}>90% match :</a>
                    </span></p>} */}
                {/* {duplicate90 &&
                    <p>
                        <p style={{ padding: 5 }}>
                            {per100Ctzn && <p><span className="card-body-label">
                                Citizenship(Dst-No-Yr):{' '}
                            </span>
                                <span className="card-body-text">
                                    <a href="#" onClick={(e) => setViewConflicDialog(per100Ctzn)}>
                                        {per100Ctzn}
                                    </a>
                                </span></p>}
                            {per90AllNameCtzn && <p><span className="card-body-label">
                                Name, Family Detail and Citizenship(Dst-No-Yr):{' '}
                            </span>
                                <span className="card-body-text">
                                    <a href="#" onClick={(e) => setViewConflicDialog(per90AllNameCtzn)}>
                                        {per90AllNameCtzn}
                                    </a>
                                </span></p>}
                            {per90AllNameCtzn19 && <p><span className="card-body-label">
                                Name, Family Detail and Citizenship(Dst-No):{' '}
                            </span>
                                <span className="card-body-text">
                                    <a href="#" onClick={(e) => setViewConflicDialog(per90AllNameCtzn19)}>
                                        {per90AllNameCtzn19}
                                    </a>
                                </span></p>}
                            {per90AllNameCtzn15 && <p><span className="card-body-label">
                                Name, Family Detail and Citizenship(No):{' '}
                            </span>
                                <span className="card-body-text">
                                    <a href="#" onClick={(e) => setViewConflicDialog(per90AllNameCtzn15)}>
                                        {per90AllNameCtzn15}
                                    </a>
                                </span></p>}
                            {per90NameCtzn && <p><span className="card-body-label">
                                Name and Citizenship(Dst-No-Yr):{' '}
                            </span>
                                <span className="card-body-text">
                                    <a href="#" onClick={(e) => setViewConflicDialog(per90NameCtzn)}>
                                        {per90NameCtzn}
                                    </a>
                                </span></p>}
                            {per90AllNameDob && <p><span className="card-body-label">
                                Name, Family Detail and DOB:{' '}
                            </span>
                                <span className="card-body-text">
                                    <a href="#" onClick={(e) => setViewConflicDialog(per90AllNameDob)}>
                                        {per90AllNameDob}
                                    </a>
                                </span></p>}
                            {per90FLNameCtzn && <p><span className="card-body-label">
                                First name, Last name and Citizenship(Dst-No-Yr):{' '}
                            </span>
                                <span className="card-body-text">
                                    <a href="#" onClick={(e) => setViewConflicDialog(per90FLNameCtzn)}>
                                        {per90FLNameCtzn}
                                    </a>
                                </span></p>}
                            {per90NDobCtzn19 && <p><span className="card-body-label">
                                Name, DOB and Citizenship(Dst-No):{' '}
                            </span>
                                <span className="card-body-text">
                                    <a href="#" onClick={(e) => setViewConflicDialog(per90NDobCtzn19)}>
                                        {per90NDobCtzn19}
                                    </a>
                                </span></p>}
                            {per90CtznDob && <p><span className="card-body-label">
                                DOB and Citizenship(Dst-No-Yr):{' '}
                            </span>
                                <span className="card-body-text">
                                    <a href="#" onClick={(e) => setViewConflicDialog(per90CtznDob)}>
                                        {per90CtznDob}
                                    </a>
                                </span></p>}</p>
                    </p>} */}

            </Card>)
    },
    C: (dd, setViewConflictCustomerDialog, isCompany) => {
        const mapid = {
            ...(dd.duplicateChkLs90.reduce((a, v) => {
                a[v.custId] = v.permKycId || v.tempKycId;
                return a;
            }, {})), ...(dd.duplicateChkLs100.reduce((a, v) => {
                a[v.custId] = v.permKycId || v.tempKycId;
                return a;
            }, {}))
        };

        const exclusionList = [];
        const toList = (str) => {
            return str && str.split(',').filter(s => !exclusionList.includes(s))
                .reduce((a, v) => {
                    exclusionList.push(v);
                    return {
                        id: a ? a.id + ',' + v : v,
                        text: a ? a.text + ',' + (mapid[v] || '-') : (mapid[v] || '-')
                    };
                }, null);
        };

        const per100Minor = toList(dd.per100Minor);
        const per100Ctzn = toList(dd.per100Ctzn);
        const per100Nid = toList(dd.per100Nid);
        const per100 = toList(dd.per100);
        const per100nCtznDob = toList(dd.per100nCtznDob);
        const per100FLNameCtznDob = toList(dd.per100FLNameCtznDob);
        const per100AllNameDobCtzn19 = toList(dd.per100AllNameDobCtzn19);

        const per90NDobCtzn19 = toList(dd.per90NDobCtzn19);
        const per90AllNameDob = toList(dd.per90AllNameDob);
        const per90AllNameCtzn = toList(dd.per90AllNameCtzn);
        const per90AllNameCtzn19 = toList(dd.per90AllNameCtzn19);
        const per90AllNameCtzn15 = toList(dd.per90AllNameCtzn15);
        const per90CtznDob = toList(dd.per90CtznDob);
        const per90NameCtzn = toList(dd.per90NameCtzn);
        const per90FLNameCtzn = toList(dd.per90FLNameCtzn);

        const duplicate100 = [
            per100Minor,
            per100Ctzn,
            per100Nid,
            per100,
            per100nCtznDob,
            per100FLNameCtznDob,
            per100AllNameDobCtzn19
        ]
            .filter(p => p)
            .map(p => p.id)
            .join(',');

        const duplicate90 = [
            per90NDobCtzn19,
            per90AllNameDob,
            per90AllNameCtzn,
            per90AllNameCtzn19,
            per90AllNameCtzn15,
            per90CtznDob,
            per90NameCtzn,
            per90FLNameCtzn
        ]
            .filter(p => p)
            .map(p => p.id)
            .join(',');

        const duplicateAll = [duplicate100, duplicate90].filter(p => p).join(',');

        return duplicate100 && <Card header={<span className="card-body-label">
            <a href="#" onClick={(e) => setViewConflictCustomerDialog(duplicateAll)}>{DataFrom[dd.dataFrom]} </a>
            {/* {!!dd.duplicateChkLs100.length && <a href="#" onClick={(e) => setViewConflictCustomerDialog(duplicate100)}>
        <Tag className=" p-overlay-badge p-ml-5" severity={"danger"} >
        {dd.duplicateChkLs100.length} Data 100% MATCH
      </Tag></a>}
      {!!dd.duplicateChkLs90.length && <a href="#" onClick={(e) => setViewConflictCustomerDialog(duplicate90)}>
        <Tag className=" p-overlay-badge p-ml-5" severity={"danger"} >
        {dd.duplicateChkLs90.length} Data 90% MATCH
      </Tag></a>} */}
        </span>}>
            {duplicate100 &&
                <p><span className="card-body-label">
                    <a href="#" onClick={(e) => setViewConflictCustomerDialog(duplicate100)}>100% match:</a>
                </span>
                    <p style={{ padding: 5 }}>
                        {per100Minor && <p><span className="card-body-label">
                            Name, DOB and Minor Birth Certificate:{' '}
                        </span>
                            <span className="card-body-text">
                                <a href="#" onClick={(e) => setViewConflictCustomerDialog(per100Minor.id)}>
                                    {per100Minor.text}
                                </a>
                            </span></p>}
                        {per100Ctzn && <p><span className="card-body-label">
                            Citizenship(Dst-No-Yr):{' '}
                        </span>
                            <span className="card-body-text">
                                <a href="#" onClick={(e) => setViewConflictCustomerDialog(per100Ctzn.id)}>
                                    {per100Ctzn.text}
                                </a>
                            </span></p>}

                        {per100Nid && <p><span className="card-body-label">
                            National Identification Number:{' '}
                        </span>
                            <span className="card-body-text">
                                <a href="#" onClick={(e) => setViewConflictCustomerDialog(per100Nid.id)}>
                                    {per100Nid.text}
                                </a>
                            </span></p>}
                        {per100 && <p><span className="card-body-label">
                            {!isCompany ? 'Name, Family Detail, DOB and Citizenship(Dst-No-Yr)' : 'Company name/Reg No/PAN'}:{' '}
                        </span>
                            <span className="card-body-text">
                                <a href="#" onClick={(e) => setViewConflictCustomerDialog(per100.id)}>
                                    {per100.text}
                                </a>
                            </span></p>}
                        {per100AllNameDobCtzn19 && <p><span className="card-body-label">
                            First Name, Last Name, DOB and Citizenship(Dst-No):{' '}
                        </span>
                            <span className="card-body-text">
                                <a href="#" onClick={(e) => setViewConflictCustomerDialog(per100AllNameDobCtzn19.id)}>
                                    {per100AllNameDobCtzn19.text}
                                </a>
                            </span></p>}
                        {per100FLNameCtznDob && <p><span className="card-body-label">
                            First Name, Last Name, DOB and Citizenship(Dst-No-Yr):{' '}
                        </span>
                            <span className="card-body-text">
                                <a href="#" onClick={(e) => setViewConflictCustomerDialog(per100FLNameCtznDob.id)}>
                                    {per100FLNameCtznDob.text}
                                </a>
                            </span></p>}
                        {per100nCtznDob && <p><span className="card-body-label">
                            Name, DOB and Citizenship(Dst-No-Yr):{' '}
                        </span>
                            <span className="card-body-text">
                                <a href="#" onClick={(e) => setViewConflictCustomerDialog(per100nCtznDob.id)}>
                                    {per100nCtznDob.text}
                                </a>
                            </span></p>}</p>
                </p>}
            {/* {duplicate90 &&
                <p><span className="card-body-label">
                    <a href="#" onClick={(e) => setViewConflictCustomerDialog(duplicate90)}>90% match:</a>
                </span>
                    <p style={{ padding: 5 }}>
                        {per90AllNameCtzn && <p><span className="card-body-label">
                            Name, Family Detail and Citizenship(Dst-No-Yr):{' '}
                        </span>
                            <span className="card-body-text">
                                <a href="#" onClick={(e) => setViewConflictCustomerDialog(per90AllNameCtzn.id)}>
                                    {per90AllNameCtzn.text}
                                </a>
                            </span></p>}
                        {per90NDobCtzn19 && <p><span className="card-body-label">
                            Name, DOB and Citizenship(Dst-No):{' '}
                        </span>
                            <span className="card-body-text">
                                <a href="#" onClick={(e) => setViewConflictCustomerDialog(per90NDobCtzn19.id)}>
                                    {per90NDobCtzn19.text}
                                </a>
                            </span></p>}
                        {per90AllNameCtzn19 && <p><span className="card-body-label">
                            Name, Family Detail and Citizenship(Dst-No):{' '}
                        </span>
                            <span className="card-body-text">
                                <a href="#" onClick={(e) => setViewConflictCustomerDialog(per90AllNameCtzn19.id)}>
                                    {per90AllNameCtzn19.text}
                                </a>
                            </span></p>}
                        {per90AllNameCtzn15 && <p><span className="card-body-label">
                            Name, Family Detail and Citizenship(No):{' '}
                        </span>
                            <span className="card-body-text">
                                <a href="#" onClick={(e) => setViewConflictCustomerDialog(per90AllNameCtzn15.id)}>
                                    {per90AllNameCtzn15.text}
                                </a>
                            </span></p>}
                        {per90NameCtzn && <p><span className="card-body-label">
                            Name and Citizenship(Dst-No-Yr):{' '}
                        </span>
                            <span className="card-body-text">
                                <a href="#" onClick={(e) => setViewConflictCustomerDialog(per90NameCtzn.id)}>
                                    {per90NameCtzn.text}
                                </a>
                            </span></p>}
                        {per90AllNameDob && <p><span className="card-body-label">
                            Name, Family Detail and DOB:{' '}
                        </span>
                            <span className="card-body-text">
                                <a href="#" onClick={(e) => setViewConflictCustomerDialog(per90AllNameDob.id)}>
                                    {per90AllNameDob.text}
                                </a>
                            </span></p>}
                        {per90FLNameCtzn && <p><span className="card-body-label">
                            First name, Last name and Citizenship(Dst-No-Yr):{' '}
                        </span>
                            <span className="card-body-text">
                                <a href="#" onClick={(e) => setViewConflictCustomerDialog(per90FLNameCtzn.id)}>
                                    {per90FLNameCtzn.text}
                                </a>
                            </span></p>}
                        {per90CtznDob && <p><span className="card-body-label">
                            DOB and Citizenship(Dst-No-Yr):{' '}
                        </span>
                            <span className="card-body-text">
                                <a href="#" onClick={(e) => setViewConflictCustomerDialog(per90CtznDob.id)}>
                                    {per90CtznDob.text}
                                </a>
                            </span></p>}</p>
                </p>} */}
        </Card>
    },
    D: (dd, setViewConflictCustomerDialog, isCompany) => AnalysisDisplay.C(dd, setViewConflictCustomerDialog, isCompany)
};
export const familyName = (row) => {
    if (!row || !row.personDetail) return '';
    const mname = row.personDetail.mname ? row.personDetail.mname + " " : "";
    return row.personDetail.fname + "  " + mname + row.personDetail.lname;
};

export const familyNameNep = (row) => {
    if (!row || !row.personDetail || !row.personDetail.fnameNep || !row.personDetail.lnameNep) return '';
    const mname = row.personDetail.mnameNep ? row.personDetail.mnameNep + " " : "";
    return row.personDetail.fnameNep + "  " + mname + row.personDetail.lnameNep;
};

export function KycInfoForPublic({
    id,
    type,
    personDetail,
    companyDetail,
    bankAccountDetailList,
    boIdList,
    dynamicDataList,
    permKycId,
    tempKycId,
    hideHeader,
    onSendButtonDisable,
    setQrInfoData,
    verifiedDate,
    districtList, reloadDuplicateData, duplicateData
}) {


    const dispatch = useDispatch();

    const [viewConflictDialog, setViewConflicDialog] = useState(false);
    const [isCleanAnalysisSelected, setIsCleanAnalysisSelected] = useState(false);
    const [viewConflictCustomerDialog, setViewConflictCustomerDialog] = useState(false);

    const name = personDetail
        ? personDetail.fname +
        " " +
        (personDetail.mname ? personDetail.mname + " " : "") +
        personDetail.lname
        : companyDetail.name;

    const {
        addressDetailList,
        occupationDetailList,
        antiMoneyLaunderingList,
        familyDetailList,
        guardianDetail,
        directorDetailList,
        biometricsDetailsList,
    } = personDetail || companyDetail || {};
    const personDocumentDetailList = personDetail
        ? personDetail.personDocumentDetailList
        : companyDetail.documentDetailList;
    //location
    let locationType =
        personDocumentDetailList &&
            personDocumentDetailList.find(
                (d) => d.documentTypeId === "MP" && d.fileId
            ) ?
            "I" : null;
    let lat = null
    let lng = null
    if (addressDetailList) {
        let tempadd = addressDetailList.find((address) => address.addressTypeId === 2);
        let peradd = addressDetailList.find((address) => address.addressTypeId === 1);
        lat = tempadd && tempadd.lat ? tempadd.lat : null;
        lng = tempadd && tempadd.lng ? tempadd.lng : null;
        if (lat && lng) locationType = 'G'
    }
    const mapDocument = personDocumentDetailList.find((d) => d.documentTypeId === "MP") || {};


    const dob = personDetail && personDetail.dob;
    // const ctzMatchPer = aiAnalysis && aiAnalysis.ctzPhotoMatchPercentage && aiAnalysis.ctzPhotoMatchPercentage.split('.')[0].replace('[', '');
    const grandFatherObj = familyDetailList && familyDetailList.find((p) => p.relationTypeId == "GF");
    const fatherObj = familyDetailList && familyDetailList.find((p) => p.relationTypeId == "F");
    const grandFatherName = familyName(grandFatherObj);
    const fatherName = familyName(fatherObj);
    const photoDoc =
        personDetail &&
        personDocumentDetailList.find((d) => d.documentTypeId === "PH");
    const ctizenshipDoc =
        personDetail &&
        personDocumentDetailList.find((d) => d.documentTypeId === "CZ");
    const nationalIdDoc =
        personDetail &&
        personDocumentDetailList.find((d) => d.documentTypeId === "NID");


    const citizenshipNo = ctizenshipDoc && ctizenshipDoc.docId;
    const nationalId = nationalIdDoc && nationalIdDoc.docId;
    const ctznIssuedYear = (ctizenshipDoc && ctizenshipDoc.issuedDate && new Date(ctizenshipDoc.issuedDate).getFullYear()) || "";

    // const [customerGeneratedBoid, setCustomerGeneratedBoid] = useState([]);
    // const [boidAnalysisList, setBoidAnalysisList] = useState([]);
    // const [boidValidityList, setBoidValidityList] = useState({});
    // const [viewConflictDialog, setViewConflicDialog] = useState(false);
    // const [isCleanAnalysisSelected, setIsCleanAnalysisSelected] = useState(false);
    // const [viewConflictCustomerDialog, setViewConflictCustomerDialog] = useState(false);

    const [czDistrict, setCzDistrict] = useState();
    const compareObject = {
        boId: "",
        custName: name || "",
        fatherName: fatherName || "",
        grandFatherName: grandFatherName || "",
        pan: (personDetail && personDetail.pan) || (companyDetail && companyDetail.pan) || "",
        dob: dob || "",
        ctznNo: (czDistrict || "") + "-" + (citizenshipNo || "") + "-" + ctznIssuedYear,
        email: (addressDetailList &&
            addressDetailList.find((address) => address.addressTypeId === 2) || {}).email,
        mobile: (addressDetailList &&
            addressDetailList.find((address) => address.addressTypeId === 2) || {}).mobileNo,
        regNo: companyDetail && companyDetail.regNo,
    }
    const user = {};

    const kycComparisionInfoObj = {
        customerName: name || "",
        tempKycId: tempKycId || "",
        permKycId: permKycId || "",
        fatherName: fatherName || "",
        grandFatherName: grandFatherName || "",
        citizenshipNo: citizenshipNo || "",
        citizenshipIssueYear: ctznIssuedYear || "",
        citizenshipIssueDistrict: czDistrict || "",
        nid: nationalId || "",
        dob: dob || "",
        pan: (personDetail && personDetail.pan) || (companyDetail && companyDetail.pan) || "",
        email: (addressDetailList &&
            addressDetailList.find((address) => address.addressTypeId === 2) || {}).email,
        phoneNo: (addressDetailList &&
            addressDetailList.find((address) => address.addressTypeId === 2) || {}).mobileNo,
        regNo: companyDetail && companyDetail.regNo,
    }
    const fetchData = () => {
        ApiService.getDuplicateDataByCustomer(id)
            .then(response => {
                dispatch(setDuplicateData(response.data.data.filter(dd => dd &&
                    (dd.per100 != null || dd.per100nCtznDob != null || dd.per100FLNameCtznDob != null
                        || dd.per100AllNameDobCtzn19 != null || dd.per100Minor != null
                    ))));
                // setDuplicateData(response.data.data.filter(dd => dd && (dd.duplicate100 || dd.duplicate90)));
            });
    };
    useEffect(() => {
        ApiService.getCustomerGeneratedBoid(id).then(r => {
            const bList = r.data.filter(boid => !user.dpId || boid.dpId === user.dpId).map(boid => boid.fullBoId);
            // setCustomerGeneratedBoid(r.data);
            if (bList.length) {
                // ApiService.getDuplicateDataByBoids(bList).then(response => {
                //     console.log("response.data.data12345999", response.data.data);
                //     setBoidAnalysisList(baList => {
                //         const list = response.data.data;
                //         console.log("response.data.data123000001", list);
                //         return ({
                //             ...baList, ...list.reduce((a, v) => {
                //                 a[v.boId] = v;
                //                 return a;
                //             }, {})
                //         })
                //     });
                // });
                // ApiService.checkBoidValidity(id, bList, { name, fatherName, grandFatherName, citizenshipNo, dob, pan: compareObject.pan, regNo: compareObject.regNo, formType: type }).then(response => {
                //     console.log('response.data.data12345:', response.data.data);
                //     setBoidValidityList(bavList => {
                //         const list = response.data.data;
                //         console.log("response.data.data123000002", list);
                //         return ({
                //             ...bavList, ...list.reduce((a, v) => {
                //                 a[v.boid] = v;
                //                 return a;
                //             }, {})
                //         })
                //     });
                // });
            }
        });
        // if (id) {
        // fetchData();
        // ApiService.getAiAnalysisCustomer(id)
        //     .then(response => {
        //         if (!response.data.data) {
        //             onSendButtonDisable(true);
        //         }
        //         setAiAnalysis(response.data.data || {});
        //     });
        // }
    }, [id]);

    useEffect(() => {
        if (reloadDuplicateData != 1) {
            const timer = setTimeout(() => {
                fetchData();
            }, 5000); // Wait for 5 seconds

            return () => clearTimeout(timer);
        }
    }, [reloadDuplicateData]);
    return (
        <div>
            {duplicateData && !!duplicateData.length && <Card style={{ width: '100%' }} header={<span><i className="pi pi-android"></i> Data Analysis</span>}> {duplicateData.map(dd => AnalysisDisplay[dd.dataFrom](
                dd, (dd2) => {
                    if (dd.dataFrom === 'B') setViewConflicDialog([dd2])
                    else {
                        setIsCleanAnalysisSelected(dd.dataFrom === 'C');
                        setViewConflictCustomerDialog(dd2);
                    }
                }, !!companyDetail))}</Card>}
            {viewConflictDialog && (
                <ViewConflictData
                    visible={viewConflictDialog}
                    onHide={() => setViewConflicDialog(false)}
                    boids={viewConflictDialog}
                    compareObject={compareObject}
                    isCompany={!!companyDetail}
                />
            )}
            {viewConflictCustomerDialog && (
                <KycComparisionInfo
                    isClean={isCleanAnalysisSelected}
                    visible={viewConflictCustomerDialog}
                    onHide={() => setViewConflictCustomerDialog(false)}
                    customerId={viewConflictCustomerDialog}
                    kycComparisionInfoObj={kycComparisionInfoObj}
                    isCompany={!!companyDetail}
                />
            )}
        </div >
    )
}